export enum LegalProtectionBaseInsuranceEnum {
  PRIVATE = 'PRIVATE',
  CIRCULATION = 'CIRCULATION',
  PRIVATE_AND_CIRCULATION = 'PRIVATE_AND_CIRCULATION',
}

export const getLegalProtectionBaseInsuranceLabel = (
  value: LegalProtectionBaseInsuranceEnum
): string => {
  switch (value) {
    case LegalProtectionBaseInsuranceEnum.CIRCULATION:
      return $localize`Circulation`;
    case LegalProtectionBaseInsuranceEnum.PRIVATE:
      return $localize`Privée`;
    case LegalProtectionBaseInsuranceEnum.PRIVATE_AND_CIRCULATION:
      return $localize`Privée et Circulation`;
    default:
      return '';
  }
};

export enum LegalProtectionCoversEnum {
  PRIVATE = 'PRIVATE',
  CIRCULATION = 'CIRCULATION',
  BUILDING = 'BUILDING',
}

export const getLegalProtectionCoverLabel = (
  value: LegalProtectionCoversEnum
): string => {
  switch (value) {
    case LegalProtectionCoversEnum.PRIVATE:
      return $localize`Privé`;
    case LegalProtectionCoversEnum.CIRCULATION:
      return $localize`Circulation`;
    case LegalProtectionCoversEnum.BUILDING:
      return $localize`Bâtiment`;
    default:
      return '';
  }
};

export enum LegalProtectionMandatoryOptionEnum {
  BUILDING = 'Immeuble',
  APPARTMENT = 'Bailleur',
}

export enum LegalProtectionOptionsEnum {
  MULTI_RISK = 'MULTI_RISK',
  INDEPENDANT = 'INDEPENDANT',
  BUILDING = 'BUILDING',
  LANDLORD = 'LANDLORD',
}
